<template>
  <div>
    <Treeselect :multiple="true" :options="options" v-model="subjects" />
    <div class="flex items-center justify-end pt-4 border-t">
      <button
        class="py-2 px-4 border border-gray-600 hover:bg-indigo-600 hover:text-white hover:border-transparent rounded focus:outline-none"
        @click="submit"
      >
        Asignar
      </button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  components: {
    Treeselect,
  },
  props: {
    teachers: {
      type: Array,
    },
  },
  data() {
    return {
      subjects: [],
    };
  },
  computed: {
    ...mapState(["tabs", "user"]),
    ...mapGetters(["currentTab"]),
    options() {
      return this.currentTab.extras.subjects.map((subject) => {
        return {
          id: subject.num,
          label: `${subject.descripcion} ${subject.ID_CURSO}`,
        };
      });
    },
  },
  methods: {
    ...mapActions(["selectTab"]),
    ...mapMutations(["hideModal"]),
    submit() {
      const subjectEntries = this.subjects.map((subject) => {
        return this.currentTab.extras.subjects.find(
          (extra) => subject === extra.num
        );
      });

      this.teachers.forEach((teacher) => {
        subjectEntries.forEach((subject) => {
          if (subject.profesores.split(",").includes(teacher.ID_Instructor)) {
            return;
          }

          if (subject.profesores.trim() === "") {
            subject.profesores = teacher.ID_Instructor;
          } else {
            subject.profesores = subject.profesores.concat(
              ",",
              teacher.ID_Instructor
            );
          }
        });
      });

      axios
        .post("server/index.php", {
          action: "asignSubjects",
          user: this.user.num,
          colegio: this.user.colegio,
          data: subjectEntries,
        })
        .then(() => {
          const tab = this.tabs.find((tab) => tab.type === "disciplines");
          this.hideModal();
          this.selectTab(tab);
        });
    },
  },
};
</script>
